
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import {
    PreloadAllModules,
    provideRouter,
    withInMemoryScrolling,
    withPreloading,
} from '@angular/router';
import { appRoutes } from './app-routing.module';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideFirebaseApp, initializeApp, FirebaseApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideAnimations } from '@angular/platform-browser/animations';
import { DialogService } from 'primeng/dynamicdialog';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { importProvidersFrom } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';
import { AppLayoutModule } from './layout/app.layout.module';
import { HttpLoaderFactory } from './app.module';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { AuthInterceptor } from './core/interceptor/auth.interceptor';
// import { VersionCheckService } from './core/services/version-check.service';


// Initialize Firebase app ONCE at the top
// const firebaseApp: FirebaseApp = initializeApp(environment.firebase);

// /**
//  * Initialize version check on app startup
//  */
// function initializeVersionCheck(versionCheckService: VersionCheckService) {
//     return () => {
//         versionCheckService.initVersionCheck();
//     };
// }



export const appConfig: ApplicationConfig = {
    providers: [
    provideRouter(appRoutes),
    provideHttpClient(
      withInterceptors([AuthInterceptor])
    ),
    provideAnimations(),

   
    provideFirebaseApp(() => initializeApp(environment.firebase)), // 
    provideFirestore(() => getFirestore()),
    provideMessaging(() => getMessaging()),
    provideAuth(() => getAuth()),
    // provideMessaging(() => getMessaging()),
    // provideDatabase(() => getDatabase()),
    // provideFirestore(() => getFirestore()),
    DialogService,
    // {
    //     provide: APP_INITIALIZER,
    //     useFactory: initializeVersionCheck,
    //     deps: [VersionCheckService],
    //     multi: true,
    // },
    importProvidersFrom(
      AngularFireModule.initializeApp(environment.firebase),
      AngularFirestoreModule,
      AngularFireAuthModule,
      AppLayoutModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    )
  ],
};
